import { extractErrorMessage } from '@zealy/utils';
import { apiV2 } from '../services';
export const getTradingCompetition = async (subdomain) => {
    const res = await apiV2.tradingCompetition.get({ params: { subdomain } });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`getTradingCompetition fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const isUserRegistered = async (subdomain, tradingCompetitionId) => {
    const res = await apiV2.tradingCompetition.isUserRegistered({
        params: { subdomain },
        query: { tradingCompetitionId },
    });
    if (res.status === 200) {
        return res.body.isRegistered;
    }
    throw new Error(`isUserRegistered fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const registerToTradingCompetition = async (subdomain, tradingCompetitionId, data) => {
    const res = await apiV2.tradingCompetition.register({
        params: { subdomain, tradingCompetitionId },
        body: data,
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`registerToTradingCompetition fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const unregisterFromTradingCompetition = async (subdomain, tradingCompetitionId) => {
    const res = await apiV2.tradingCompetition.unregister({
        params: { subdomain, tradingCompetitionId },
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`unregisterFromTradingCompetition fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const getTradingCompetitionLeaderboard = async (subdomain, tradingCompetitionId, page = 1, pageSize = 20) => {
    const res = await apiV2.tradingCompetition.getLeaderboard({
        params: { subdomain, tradingCompetitionId },
        query: { page, pageSize },
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`getTradingCompetitionLeaderboard fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const getUserTradingRank = async (subdomain, tradingCompetitionId, userId) => {
    const res = await apiV2.tradingCompetition.getUserRank({
        params: { subdomain, tradingCompetitionId, userId },
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`getUserTradingRank fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const refreshUserScore = async (subdomain, tradingCompetitionId) => {
    const res = await apiV2.tradingCompetition.refreshUserScore({
        params: { subdomain, tradingCompetitionId },
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`refreshUserScore fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
export const getAllTradingCompetitions = async (subdomain) => {
    const res = await apiV2.tradingCompetition.getAll({
        params: { subdomain },
    });
    if (res.status === 200) {
        return res.body;
    }
    throw new Error(`getAllTradingCompetitions fail: status=${res.status}, message=${extractErrorMessage(res.body)}`);
};
